import { render } from "./UserMenu.vue?vue&type=template&id=8ea31026&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"

import "./UserMenu.vue?vue&type=style&index=0&id=8ea31026&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ea31026"]])

export default __exports__